import * as React from 'react';
import { CreditCardBrand } from '@sdk/account/types/apiTypes';

import visaPng from '../../../assets/images/visa.png';
import masterCardPng from '../../../assets/images/mastercard.png';
import americalExpressPng from '../../../assets/images/american-express.png';

import { CcImg } from './creditCardLogo.styles';

type Props = {
  type: CreditCardBrand;
  showActiveOnly?: boolean;
};

const CreditCardLogo: React.FC<React.PropsWithChildren<Props>> = ({ type, showActiveOnly }) => (
  <>
    {type === CreditCardBrand.visa || !showActiveOnly ? (
      <CcImg src={visaPng} active={type === CreditCardBrand.visa} />
    ) : null}
    {type === CreditCardBrand.masterCard || !showActiveOnly ? (
      <CcImg src={masterCardPng} active={type === CreditCardBrand.masterCard} />
    ) : null}
    {type === CreditCardBrand.americanExpress || !showActiveOnly ? (
      <CcImg src={americalExpressPng} active={type === CreditCardBrand.americanExpress} />
    ) : null}
  </>
);

export default CreditCardLogo;
